import { formatIncompletePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

export const parsePhoneOnType = (value: string): string => formatIncompletePhoneNumber(`+${value.replace(/[+]/g, '')}`);
export const isPhoneInvalid = (value: string): boolean => !isValidPhoneNumber(value);
